import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import TireModel from './tire-model';
import TireModelUpdate from './tire-model-update';
import TireModelDeleteDialog from './tire-model-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={TireModelUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={TireModelUpdate} />
      <ErrorBoundaryRoute path={match.url} component={TireModel} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={TireModelDeleteDialog} />
  </>
);

export default Routes;
